// export const GUARD_APPLICATION_FORM = "guard_application_form";
// export const CLIENT_INFO_FORM = "client_info_form";
// export const SECURITY_GUARD_INTERVIEW = "security_guard_interview";
export const ROOT = '/test-results';
export const MODULE = 'TEST_RESULTS';

export const DRIVING_TEST_FORM = "driving_test_form";